import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_STATUS_CANCEL_RESET = 'PUT_ROUTE_STATUS_CANCEL_RESET';
export const PUT_ROUTE_STATUS_CANCEL_LOADING = 'PUT_ROUTE_STATUS_CANCEL_LOADING';
export const PUT_ROUTE_STATUS_CANCEL_SUCCESS = 'PUT_ROUTE_STATUS_CANCEL_SUCCESS';
export const PUT_ROUTE_STATUS_CANCEL_REJECT = 'PUT_ROUTE_STATUS_CANCEL_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteStatusCancelReset = () => ({ type: PUT_ROUTE_STATUS_CANCEL_RESET });
export const putRouteStatusCancelLoading = () => ({ type: PUT_ROUTE_STATUS_CANCEL_LOADING });
export const putRouteStatusCancelSuccess = (payload) => ({ type: PUT_ROUTE_STATUS_CANCEL_SUCCESS, payload });
export const putRouteStatusCancelReject = (payload) => ({ type: PUT_ROUTE_STATUS_CANCEL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteStatusCancelRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        params: { IdRoute: data.idRoute },
    }, getState);
    return request(`/Route/web/UpdateRouteChangestatusCancelRoute`, options);
};